export default{

    api_decode : '',
    api_authentication: '',
    host_authentication : '',
    firebase_config_game : '',
    firebase_config_chat : ''
}